import React from "react";

export function getUrlParam(inputUrl = '', key = '') {
    const url = new URL(inputUrl);
    const searchParams = new URLSearchParams(url.search);
    return searchParams.has(key) ? searchParams.get(key) : undefined;
}